import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import UpsellPage from "@/pages/UpsellPage";
import ObrigadoPage from "@/pages/ObrigadoPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Navigate to="/upsell" replace />} />
          <Route path="/upsell" element={<UpsellPage />} />
          <Route path="/obrigado" element={<ObrigadoPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
